export enum Columns {
  Actions = 'actions',
  Name = 'name',
  Users = 'users',
  Subscription = 'subscription',
  Displays = 'displays',
}
